const apiName = "https://exams.aspireitacademy.com/"; // Real world Api
// const apiName = "https://exam.prod-app.in/" // Testing Api
export default apiName;